export const pipSize = (pair) => (pair && pair.includes('JPY') ? 0.01 : 0.0001);

export const roundTo = (v, digits) => Number(Number(v).toFixed(digits));

export const pipsBetween = (a, b, pair) => Math.round((Math.abs(a - b) / pipSize(pair)) * 10) / 10;

export const lotForRisk = (risk, slPips, pvLot) => {
  if (!risk || !slPips || !pvLot || slPips <= 0) return 0;
  return Math.max(0.01, Math.floor((risk / (slPips * pvLot)) * 100 + 1e-9) / 100);
};

export const validateStop = (dir, price, entry, sl, tp) => {
  if (!price || !entry || !sl || !tp) return 'Waiting for live price…';
  if (dir === 'BUY') {
    if (entry <= price) return 'Buy Stop entry must be ABOVE the current price';
    if (sl >= entry) return 'Stop Loss must be BELOW the entry';
    if (tp <= entry) return 'Take Profit must be ABOVE the entry';
  } else {
    if (entry >= price) return 'Sell Stop entry must be BELOW the current price';
    if (sl <= entry) return 'Stop Loss must be ABOVE the entry';
    if (tp >= entry) return 'Take Profit must be BELOW the entry';
  }
  return null;
};

// Build Entry/SL/TP for a stop order from a notification (keeps its SL/TP pip distances).
export const buildLevels = (dir, price, pair, digits, setup = {}) => {
  const ps = pipSize(pair);
  const sign = dir === 'BUY' ? 1 : -1;
  const src = setup.entry_price;
  const slP = src && setup.sl_price ? Math.max(3, pipsBetween(src, setup.sl_price, pair)) : 20;
  const tpP = src && setup.tp_price ? Math.max(3, pipsBetween(src, setup.tp_price, pair)) : 20;
  const validSrc = src && (dir === 'BUY' ? src > price : src < price);
  const entry = validSrc ? src : price + sign * 2 * ps;
  return {
    entry: roundTo(entry, digits),
    sl: roundTo(entry - sign * slP * ps, digits),
    tp: roundTo(entry + sign * tpP * ps, digits),
  };
};

export const pnlAt = (o, price) => {
  const sign = o.direction === 'BUY' ? 1 : -1;
  const pips = (sign * (price - o.entry_price)) / pipSize(o.pair);
  return Math.round(pips * (o.pip_value_per_lot || 0) * o.lot_size * 100) / 100;
};

const rUnit = (o) => Math.abs(o.entry_price - (o.original_sl_price ?? o.sl_price));

export const rMultiple = (o, price) => {
  const r = rUnit(o);
  const sign = o.direction === 'BUY' ? 1 : -1;
  return r ? (sign * (price - o.entry_price)) / r : 0;
};

export const lockPrice = (o, rMult, digits) => roundTo(o.entry_price + (o.direction === 'BUY' ? 1 : -1) * rMult * rUnit(o), digits);

export const money = (v) => `$${Number(v || 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
